import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material';
import { environment } from 'src/environments/environment.prod';
import * as moment from 'moment';


@Component({
  selector: 'app-getdata',
  templateUrl: './getdata.component.html',
  styleUrls: ['./getdata.component.css'],
  providers: [
    DatePipe
  ],
  // encapsulation: ViewEncapsulation.None
})

export class GetdataComponent implements OnInit {

  


  displayedColumns: string[] = ['requestType', 'rpName', 'endTime'];
  resultre: any;
  dataSource = [];
  groupedData = [];
  events: any;
  change: any;
  maxDate= new Date()
  date: Date = new Date();
  formatedDate: any;
  dispalyDate:any;
  number:any;

  currentDate = new Date()
  todate: any;

  todaysDate: any;
  tomorrow = new Date().getTime() + 24 * 60 * 60 * 1000;
  tomorrowsDate: any;

  yesterday = new Date().getTime() - 24 * 60 * 60 * 1000;
  yesterdaysDate: any

  getresponse: any;

  isdisabled: boolean=true

  getData_url:any="";

  public show:boolean = false;
  public hide:boolean = false;
  public buttonName:any = 'Show';

  convert(str) {
    var changedDate = new Date(str),
      mnth = ("0" + (changedDate.getMonth() + 1)).slice(-2),
      day = ("0" + changedDate.getDate()).slice(-2);
    return [mnth, day, changedDate.getFullYear()].join("/");
  }
  getTime(str) {
    
    var time = new Date(str);
    var time1= str.split('T')[1];

    
    var time2 = time1.split('.')[0];
    
    return time2;
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.events = event.value;
    this.change = this.convert(this.events);
    this.todate = this.change;
    this.getTransactionByDate();
  }

  data2 = new FormGroup({
    todate: new FormControl()
  })

  constructor(private http: HttpClient, private router: Router, private datePipe: DatePipe, private formBuilder: FormBuilder) { }

  ngOnInit() {

    // document.getElementById('sidemenu').style.display = 'none';

    // this.number=sessionStorage.getItem("id")
    

   this.getData_url=environment.getData_url;
   // this.getData_url="https://secureid.jiolabs.com/portalbackend/getTransactions?"
    document.getElementById('loader').style.display = 'block';
    this.data2 = this.formBuilder.group({

      todate: ['', Validators.required],
    })


    this.todaysDate = this.datePipe.transform(this.currentDate, "yyyy-MM-dd")
    this.formatedDate = this.datePipe.transform(this.date, "MM/dd/yyyy")
    this.tomorrowsDate = this.datePipe.transform(this.tomorrow, "MM/dd/yyyy")
    this.yesterdaysDate = this.datePipe.transform(this.yesterday, "yyyy-MM-dd")
     console.log( this.formatedDate,this.tomorrowsDate)
    //get transaction data call
    this.http.get(this.getData_url,
      {
        params: {
          "fromDate": this.formatedDate,
          "toDate": this.tomorrowsDate
        },
        withCredentials: true
      }
    ).subscribe(
      data => {
        document.getElementById('loader').style.display = 'none';
        this.getresponse = data;
        this.dataSource = this.getresponse.txnList;
        
        //group data bydate
        var result1 = this.dataSource.reduce(function (r, a) {
          const date = a.endTime.split('T')[0];
          r[date] = r[date] || [];
          r[date].push(a);
          return r;
        }, Object.create(null));

        //convert it into arraymap
        this.groupedData = Object.keys(result1).map(key => ({
          type: key,
          value: result1[key]
        }));

      },

      err => {
        
        document.getElementById('loader').style.display = 'none';
        
        if (err.error.errorCd == '0100') {
          document.getElementById('error1').style.display = 'block';
        } else if (err.error.errorCd == '0101') {
          document.getElementById('error2').style.display = 'block';
        }
        else if (err.error.errorCd == '0102') {
          document.getElementById('error3').style.display = 'block';
        }
        else if (err.error.errorCd == '0123') {
          document.getElementById('error4').style.display = 'block';
        }
        else if (err.error.errorCd == '0115') {
          document.getElementById('error5').style.display = 'block';
        }

      }
    );
  }


  get f() {
    return this.data2.controls;
  }

  getTransactionByDate() {
    document.getElementById('loader').style.display = 'block';
    this.todaysDate = this.datePipe.transform(this.currentDate, "yyyy-MM-dd")
    this.http.get(this.getData_url,
      {
        params: {
          "fromDate": this.todate,
          "toDate": this.tomorrowsDate

        }, withCredentials: true
      }

    ).subscribe(
      data => {
       
        document.getElementById('loader').style.display = 'none';
        this.getresponse = data;
        this.dataSource = this.getresponse.txnList;

        //group data by date
        var result1 = this.dataSource.reduce(function (r, a) {
          const date = a.endTime.split('T')[0];
          r[date] = r[date] || [];
          r[date].push(a);
          return r;
        }, Object.create(null));

        //convert it into arraymap
        this.groupedData = Object.keys(result1).map(key => ({
          type: key,
          value: result1[key]
        }));
      },
      err => {
        document.getElementById('loader').style.display = 'none';
        console.log(err.error)
        if (err.error.errorCd == '0100') {
          document.getElementById('error1').style.display = 'block';
        } else if (err.error.errorCd == '0101') {
          document.getElementById('error2').style.display = 'block';
        }
        else if (err.error.errorCd == '0102') {
          document.getElementById('error3').style.display = 'block';
        }
        else if (err.error.errorCd == '0123') {
          document.getElementById('error4').style.display = 'block';
        }
        else if (err.error.errorCd == '0115') {
          document.getElementById('error5').style.display = 'block';
        }

      }
    );
  }

  closewrong() {
    document.getElementById('error1').style.display = 'none';
    document.getElementById('error2').style.display = 'none';
    document.getElementById('error3').style.display = 'none';
    document.getElementById('error4').style.display = 'none';
    document.getElementById('error5').style.display = 'none';

  }

  menu(){
      // document.getElementById('sidemenu').style.display = 'block'
  }
  closemenu(){
    // document.getElementById('sidemenu').style.display = 'none'
  }
  transaction(){
    // document.getElementById('sidemenu').style.display = 'none'
  }
  changenumnber()
  {
    this.number=sessionStorage.getItem("id")
    
    window.open("https://smartid-sit.jio.com/smartid/changePhoneNumber/#/authenticate/" + this.number)
  }
  logout()
  {
  sessionStorage.clear()
  this.router.navigateByUrl("https://secureid.jiolabs.com/secureid/product/#/login");
  window.location.href = 'https://secureid.jiolabs.com/secureid/product/#/login';
  }
  faq(){
    this.router.navigateByUrl("/Faq")
  }
}



